import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import InputField from 'src/components/FormControls/InputField';
import { countryFields } from 'src/models/country';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export const ModalCountry = ({
  openModalCountry,
  onOpenModalCountry,
  onSubmit,
  handleSubmit,
  idCountry,
  ...formItems
}) => {
  const { t } = useTranslation();

  return (
    <Dialog fullWidth maxWidth="md" open={openModalCountry} onClose={() => onOpenModalCountry(false)}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => onOpenModalCountry(false)} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {idCountry
              ? t('actions.update', { name: countryFields.country.label })
              : t('actions.add', { name: countryFields.country.label })}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputField {...formItems} name={countryFields.name.name} label={countryFields.name.label} required />
          </Grid>
          <Grid item xs={6}>
            <InputField {...formItems} name={countryFields.code.name} label={countryFields.code.label} required />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onOpenModalCountry(false)}>
          {t('actions.cancel', { name: countryFields.country.label })}
        </Button>
        <Button onClick={handleSubmit(onSubmit)}>
          {idCountry
            ? t('actions.save', { name: countryFields.country.label })
            : t('actions.create', { name: countryFields.country.label })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
ModalCountry.propTypes = {
  idCountry: PropTypes.string,
  openModalCountry: PropTypes.bool,
  roles: PropTypes.array,
  watch: PropTypes.func,
  onOpenModalCountry: PropTypes.func,
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func
};
